<div class="m-global">
  <app-ui-section-header
    [title]="'GLOBAL.TITLE' | translate"
    [description]="'GLOBAL.SUBTITLE' | translate"
  />

  @if (isLoading()) {
  <div class="m-global__loading">{{ 'COMMON.LOADING' | translate }}</div>
  } @else if (error()) {
  <div class="m-global__error">{{ 'COMMON.ERROR' | translate }}: {{ error() }}</div>
  } @else if (config(); as cfg) {
  <div class="m-global__grid">
    <!-- Settings Card -->
    <div class="m-card">
      <h3 class="m-card__title">{{ 'GLOBAL.SETTINGS.TITLE' | translate }}</h3>
      <div class="m-global__settings">
        <div class="m-global__setting">
          <label class="m-global__setting-label">{{
            'GLOBAL.SETTINGS.DELIVERIES_REFRESH' | translate
          }}</label>
          <input
            type="number"
            [value]="cfg.deliveriesRefreshEvery"
            (input)="onDeliveriesRefreshChange(+$any($event.target).value)"
            class="m-global__input"
            min="0"
          />
        </div>
        <div class="m-global__setting">
          <label class="m-global__setting-label">{{
            'GLOBAL.SETTINGS.MAX_DAYS_EVAL' | translate
          }}</label>
          <input
            type="number"
            [value]="cfg.maximumDaysForEval"
            (input)="onMaxDaysForEvalChange(+$any($event.target).value)"
            class="m-global__input"
            min="0"
          />
        </div>
        <div class="m-global__setting">
          <label class="m-global__setting-label">{{
            'GLOBAL.SETTINGS.MAX_CO_UC' | translate
          }}</label>
          <input
            type="number"
            [value]="cfg.maximumCoForUcActivate"
            (input)="onMaxCoForUcChange(+$any($event.target).value)"
            class="m-global__input"
            min="0"
          />
        </div>
        <div class="m-global__setting">
          <label class="m-global__setting-label">{{
            'GLOBAL.SETTINGS.TICKET_DISPLAY_TIME' | translate
          }}</label>
          <input
            type="text"
            [value]="cfg.ticketDisplayTimeResolved"
            (input)="onTicketDisplayTimeChange($any($event.target).value)"
            class="m-global__input"
          />
        </div>
        <div class="m-global__setting">
          <label class="m-global__setting-label">{{
            'GLOBAL.SETTINGS.APP_VERSION' | translate
          }}</label>
          <input
            type="text"
            [value]="cfg.version"
            class="m-global__input m-global__input--disabled"
            disabled
          />
        </div>
      </div>
    </div>

    <!-- Global Features Card -->
    <div class="m-card">
      <h3 class="m-card__title">{{ 'GLOBAL.FEATURES.TITLE' | translate }}</h3>
      <div class="m-global__features">
        <div class="m-global__feature">
          <span class="m-global__feature-label">{{
            'GLOBAL.FEATURES.DECLARATOR' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.declarator"
              (change)="
                onFeatureChange({ feature: 'declarator', enabled: $any($event.target).checked })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__feature">
          <span class="m-global__feature-label">{{
            'GLOBAL.FEATURES.EXTERNAL_DECLARATOR' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.external_declarator"
              (change)="
                onFeatureChange({
                  feature: 'external_declarator',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__feature">
          <span class="m-global__feature-label">{{ 'GLOBAL.FEATURES.SAP' | translate }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.sap"
              (change)="onFeatureChange({ feature: 'sap', enabled: $any($event.target).checked })"
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__feature">
          <span class="m-global__feature-label">{{ 'GLOBAL.FEATURES.MAP' | translate }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.map"
              (change)="onFeatureChange({ feature: 'map', enabled: $any($event.target).checked })"
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__feature">
          <span class="m-global__feature-label">{{
            'GLOBAL.FEATURES.CHATGPT_PREDICTION' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.chatGPTPrediction"
              (change)="
                onFeatureChange({
                  feature: 'chatGPTPrediction',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Salesforce Chat Card -->
    <div class="m-card">
      <h3 class="m-card__title">{{ 'GLOBAL.SALESFORCE_CHAT.TITLE' | translate }}</h3>
      <div class="m-global__sf-grid">
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.EDIT_ORDER' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.EDIT_ORDER"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'EDIT_ORDER',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.MISSING_SUPPORT' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.MISSING_SUPPORT"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'MISSING_SUPPORT',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{ 'GLOBAL.SALESFORCE_CHAT.DELAY' | translate }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.DELAY"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'DELAY',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.RECLAMATION' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.RECLAMATION"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'RECLAMATION',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.DEGRADATION' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.DEGRADATION"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'DEGRADATION',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.QUALITY_ISSUE' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.QUALITY_ISSUE"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'QUALITY_ISSUE',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.RECURRENT_DELAY' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.RECURRENT_DELAY"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'RECURRENT_DELAY',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
        <div class="m-global__sf-feature">
          <span class="m-global__sf-label">{{
            'GLOBAL.SALESFORCE_CHAT.TROUBLESHOOTING' | translate
          }}</span>
          <label class="m-toggle">
            <input
              type="checkbox"
              [checked]="cfg.features.salesforceChat.TROUBLESHOOTING"
              (change)="
                onSalesforceChatFeatureChange({
                  ticketType: 'TROUBLESHOOTING',
                  enabled: $any($event.target).checked
                })
              "
            />
            <span class="m-toggle__slider"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- Function Titles Card -->
  <div class="m-card m-global__function-card">
    <h3 class="m-card__title">{{ 'GLOBAL.FUNCTION_TITLES.TITLE' | translate }}</h3>
    <div class="m-global__function-titles">
      @for (title of cfg.functionTitles; track $index) {
      <div class="m-global__badge">
        {{ title }}
        <button
          type="button"
          class="m-global__badge-remove"
          (click)="onDeleteFunctionTitle($index)"
          [title]="'COMMON.DELETE' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      }
      <button type="button" class="m-global__add-badge" (click)="onAddFunctionTitle()">
        <mat-icon>add</mat-icon>
        {{ 'COMMON.ADD' | translate }}
      </button>
    </div>
  </div>

  }
</div>

<!-- Modal pour ajouter un titre de fonction -->
<app-ui-modal
  [isOpen]="isAddFunctionTitleModalOpen()"
  [title]="'GLOBAL.FUNCTION_TITLES.ADD_TITLE' | translate"
  (closed)="onCancelAddFunctionTitle()"
>
  <div class="m-global__modal-content">
    <label class="m-global__modal-label">
      {{ 'GLOBAL.FUNCTION_TITLES.ENTER_TITLE' | translate }}
    </label>
    <input
      type="text"
      class="m-global__modal-input"
      [(ngModel)]="newFunctionTitle"
      [placeholder]="'GLOBAL.FUNCTION_TITLES.PLACEHOLDER' | translate"
      (keyup.enter)="onConfirmAddFunctionTitle()"
    />
    <div class="m-global__modal-actions">
      <button
        type="button"
        class="m-global__modal-btn m-global__modal-btn--cancel"
        (click)="onCancelAddFunctionTitle()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="m-global__modal-btn m-global__modal-btn--confirm"
        (click)="onConfirmAddFunctionTitle()"
      >
        {{ 'COMMON.CONFIRM' | translate }}
      </button>
    </div>
  </div>
</app-ui-modal>
